import 'slick-carousel';

export default class Sliders {
    constructor() {
        console.info('Sliders.constructor()');

        if ($('.js-slider--products').length) {
            this.productSlider('.js-slider--products');
        }
    }

    productSlider(element) {
        console.info('Sliders.productSlider()');

        $(element).slick({
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: false,
            centerMode: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: false,
            variableWidth: false,
            draggable: false,
            swipeToSlide: false,
            touchMove: false,
            prevArrow:
                '<div class="slick-btn--prev"><button type="button" class="slick-prev"><div class="icon"></div></button></div>',
            nextArrow:
                '<div class="slick-btn--next"><button type="button" class="slick-next"><div class="icon"></div></button></div>',
            responsive: [
                {
                    breakpoint: 875,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }
}
